import React, { createContext, useEffect, useReducer, useState } from 'react';
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";
import SessionOut from "../../views/sessions/SessionOut";
import useError from "../../hooks/useError";

const initialValue = {
    categories: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                category_list: action.payload,
            }
        }
        case 'UPDATE_DASHBOARD_DATA': {
            return {
                ...state,
                category_list: action.payload,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const CategoryContext = createContext({
    category_list: initialValue,
    getCategories: () => { },
    addCategory: () => { },
    updateCategory: () => { },
    uploadImage: () => { },
    getCategoryById: () => { },
    changeProductDelivery: () => { },
})

export const CategoryProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const { setError } = useError();



    const changeProductDelivery = async (category_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            return await axios.get(`/api/products/change_product_delivery_by_category/${category_id}/${status}`, options);
        } catch (e) {
            if (e.response.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return e;
        }
    }

    const getCategories = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/categories/get_categories', options);

            dispatch({
                type: 'LOAD_DASHBOARD_DATA',
                payload: res.data,
            })
        } catch (e) {
            if (e.response?.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response?.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response?.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
        }
    }


    const uploadImage = async (data) => {
        try {
            const options = {
                headers: { 'Content-Type': 'multipart/form-data' }
            }

            const res = await axios.post('/api/upload_product_image', data, options);

            return res.data;
        } catch (e) {
            if (e.response?.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response?.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response?.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return null;
        }
    }

    const getCategoryById = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }
            const res = await axios.get('/api/categories/get_category/' + id, options);

            return res.data;
        } catch (e) {
            if (e.response?.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response?.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response?.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return null;
        }
    }

    const addCategory = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/categories/add_category', data, options);
            getCategories();

            return res;
        } catch (e) {

            if (e.response?.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response?.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response?.status === 500) {
                const errorMsg = JSON.parse(JSON.stringify(e));
                setError({ title: "Sorry", message: errorMsg?.msg, status: 400 })
            } else {

                const errorMsg = JSON.parse(JSON.stringify(e));
                setError({ title: "Sorry", message: errorMsg?.message, status: 400 })
            }
            return e;
        }
    }

    const updateCategory = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/categories/update_category', data, options);
            getCategories();
            return res;
        } catch (e) {
            if (e.response?.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response?.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })
            } else if (e.response?.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return e;
        }
    }

    useEffect(() => {
        getCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if (state.status === 401) {
        return <SessionOut />
    }

    if (state.category_list === undefined) {
        return <MatxLoading />
    }

    return (
        <CategoryContext.Provider
            value={{
                category_list: state.category_list,
                getCategories,
                addCategory,
                updateCategory,
                uploadImage,
                getCategoryById,
                changeProductDelivery,
            }}
        >
            {children}
        </CategoryContext.Provider>
    )
}

export default CategoryContext
